import React, {useEffect, useState, useRef} from 'react';
import { useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import '../css/RecruitmentDetail.css' ;
import Text from '../../../common/Text.js';
import imgProcess from '../img/img_recruitmentprocess.png';
import imgRect from '../img/imgRect.png';
import AttachFiles from '../../../common/AttachFiles.js';
import Cursor from 'quill/blots/cursor.js';

function RecruitmentDetail() {
    const [detailItem, SetDetailItem] = useState([]);

    const location = useLocation();
    var cardkey = location.state?.cardkey;
    const preCardKeyRef = useRef();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect( ()  => {
        if(!isLoggedIn)
            {
                axios.post('/sessionCheck')
                .then((res) => {
                    if(res.data=='인증완료')
                        {
                            setIsLoggedIn(true);
                        }
                    else
                        {
                            setIsLoggedIn(false);
                        }
                })
            }

        if (preCardKeyRef.current !== cardkey) {
            getDetailData();
        }
        preCardKeyRef.current = cardkey;
        window.scrollTo(0,0);


        const targetDiv = document.querySelector('.recruit-content-box');
        const targetDiv2 = document.querySelector('.recruit-content-img');
        //수정 필요!
        if (cardkey === 67) {
            
            targetDiv2.style.display = "block";
            targetDiv2.style.marginBottom  = "40px";

      
            // 2. 요소가 존재하고 아직 숨겨지지 않았을 때 처리
            if (targetDiv) {
              // 화면에서 안 보이게 만들기 (공유 공간도 제거)
              targetDiv.style.display = 'none';
              
              // 혹은 공간을 유지하고 싶다면: targetDiv.style.visibility = 'hidden';
            }
          }
          else
          {
            targetDiv2.style.display = "none";
      
            // 2. 요소가 존재하고 아직 숨겨지지 않았을 때 처리
            if (targetDiv) {
              // 화면에서 안 보이게 만들기 (공유 공간도 제거)
              targetDiv.style.display = 'block';
              
              // 혹은 공간을 유지하고 싶다면: targetDiv.style.visibility = 'hidden';
            }
          }


    }, [cardkey]);

    //데이터 가져오기
    const getDetailData = async () => {
        axios.get('/api/RecruitDetailSelect',{params:{id:cardkey}})
        .then(response => {SetDetailItem(response.data);})
        .catch(error => console.error("DB 가져오기 오류", error));
    }

    const currentOnlyNotice = detailItem && 
        Array.from(new Set(detailItem
            .filter(notice => notice.MatchType === 'Current')
            .map(notice => notice.Seq))) 
        .map(id => detailItem.find(notice => notice.Seq === id));

    console.log(currentOnlyNotice);

    const currentNotice = detailItem && detailItem.filter(notice => notice.MatchType === 'Current'); 
    const sideNotice = detailItem && detailItem.filter(notice => notice.MatchType === 'Side');

    ////Navigate 
    const navigate = useNavigate();

    //관리자 수정 클릭이벤트
    const handleEditClick = (seq) => {
        navigate('/Recruit', {
            state: { 
                cardkey: seq,
                mode: 'edit'
            },});
    };

    //관리자 신규 클릭이벤트
    const handleNewClick = (seq) => {
        navigate('/Recruit', {
            state: { 
                cardkey: seq,
                mode: 'new'
            },});
    };

    const handleDeleteClick = () => {
        const isDel = window.confirm("공고를 삭제하시겠습니까?");
        console.log(cardkey);
        if(isDel) {
            axios.delete('/api/RecruitJobDelete',{params:{seq:cardkey, childSeq: 'valNull'}}) //낱개 직무가 아닌 통째로 삭제할 때는 childSeq를 안 넘겨준다. 
            .then(alert("삭제되었습니다."))
            .catch(error => console.error("DB 가져오기 오류", error));
        }
        else if(!isDel) {
            return;
        }
        navigate('/RecruitmentCard');

    }

    const ZoomIMGClick = (cardkey) => {
      if(window.innerWidth > 1200)
      {
        navigate('/RecruitmetIMGPopup', {
            state: { 
                cardkey: cardkey
            },});
      }
    }

    //전체보기 클릭이벤트
    const tolistBtnClick = () => {
            navigate('/RecruitmentCard');

    };

    //side 클릭이벤트
    const sideRecruitBtnClick = (seq) => {
        navigate('/RecruitmentDetail', {
            state: { 
                cardkey: seq
            },});
    };

    //회사생활 클릭이벤트
    const toCompCultureClick = () => {
        navigate('/PersonnelSystem');
};

return(
        <div > 
            <div className='detailRecruitRoot'>
                    <Text variant='titlename'>
                        <div className='HeaderParent'>
                            <div className='Header'>채용공고</div>
                        </div>
                    </Text>
                
                {/* 관리자 버튼 */}

                    {isLoggedIn && 
                        <>
                            <button className='btnAdmin' onClick={() => handleEditClick(preCardKeyRef.current)}>
                                수정
                            </button>
                            <button className='btnAdmin' onClick={() => handleNewClick()}>
                                신규생성
                            </button>        
                            <button className='btnAdmin' onClick={handleDeleteClick}>
                                삭제
                            </button>                        
                        </>
                    } 


                {/* 제목파트 */}
                {currentOnlyNotice.map((selectedTitle) => {
                        return <div className='recruitTitle' >
                        <Text variant='px32w500W' className='recruit-subtitle'>{selectedTitle.Noti_title}</Text>
                        <Text variant='px20w500O'>  {selectedTitle.Experience} | {selectedTitle.Noti_dt} ~{' '}  {cardkey === 67 ? '2026.07.17' : '모집 완료 시'}</Text>
                        {/* <Text variant='px20w500O'>{selectedTitle.Experience} | {selectedTitle.Noti_dt} ~ 모집 완료 시</Text> */}
                        </div>
                })}
                <div className='recruitMain'>

                    <div className='recruit-content-container'>
                    <div className='recruit-content-img'>
                        <img className='recruit-imgs' src={imgRect}  onClick={() => ZoomIMGClick(preCardKeyRef.Seq)} />
                        

                    <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 입사 지원서 및 접수처</div>
                            </Text>
                            <div style={{display: 'flex', flexDirection : 'column'}}>
                                <div>  <div className='recruit-content-items'>
                                    <div className='recruit-contents_title' >- 입사 지원서 : </div>
                                    <AttachFiles uploadId='a48b1ba5-6276-4811-a90a-67d93c623176' style={{Cursor : 'Hand', fontSize: '16px', marginTop: '-4px', marginLeft : '4px'}}/> 
                                </div>
                  
                                <div className='recruit-content-items23' >- 접수처 : gaeul920.kim@partner.samsung.com</div>
                            </div>
                    </div>
                   
                   
                     </div>

                        <div className='recruit-content-box'>
                            {/* 채용유형 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 채용 유형</div>
                            </Text>
                            {currentNotice.map((selectedRecruit) => {
                                const employType = selectedRecruit.Employtype && selectedRecruit.Employtype.split(';');
                                return <div> 
                                    <Text variant='px20w600_rec' className='recruit-content-items'>[{selectedRecruit.ChildSeq}]</Text>
                                    {employType && employType.map((details) => {
                                        return <Text variant='px20w400_rec' className='recruit-content-items'>- {details}</Text> 
                                    })}
                                </div>
                            })}
                            <br /><br />

                            {/* 채용인원 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 채용 인원</div>
                            </Text>
                            {currentNotice.map((selectedRecruit) => {
                                return <div> 
                                    <Text variant='px20w600_rec' className='recruit-content-items'>[{selectedRecruit.ChildSeq}]</Text>
                                    <Text variant='px20w400_rec' className='recruit-content-items'>- {selectedRecruit.PerNum}명</Text>
                                </div>
                            })}
                            <br /><br />

                            {/* 담당업무 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 담당업무</div>
                            </Text>
                            {currentNotice.map((selectedRecruit) => {
                                const job = selectedRecruit.Job && selectedRecruit.Job.split(';');
                                return <div> 
                                    <Text variant='px20w600_rec' className='recruit-content-items'>[{selectedRecruit.ChildSeq}]</Text>
                                    {job && job.map((details) => {
                                        return <Text variant='px20w400_rec' className='recruit-content-items'>- {details}</Text> 
                                    })}
                                </div>
                            })}
                            <br /><br />

                            {/* 지원자격 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 지원자격</div>
                            </Text>
                            {currentNotice.map((selectedRecruit) => {
                                const required = selectedRecruit.Required_Detail && selectedRecruit.Required_Detail.split(';');
                                return <div> 
                                    <Text variant='px20w600_rec' className='recruit-content-items'>[{selectedRecruit.ChildSeq}]</Text>
                                    {required && required.map((details) => {
                                        return <Text variant='px20w400_rec' className='recruit-content-items'>- {details}</Text> 
                                    })}
                                </div>
                            })}
                            <br /><br />

                            {/* 우대사항 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 우대사항</div>
                            </Text>
                            {currentNotice.map((selectedRecruit) => {
                                const preferred = selectedRecruit.Preferred_Detail && selectedRecruit.Preferred_Detail.split(';');
                                return <div> 
                                    <Text variant='px20w600_rec' className='recruit-content-items'>[{selectedRecruit.ChildSeq}]</Text>
                                    {preferred && preferred.map((details) => {
                                        return <Text variant='px20w400_rec' className='recruit-content-items'>- {details}</Text> 
                                    })}
                                </div>
                            })}
                            <br /><br />

                            {/* 채용절차 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 채용 절차</div>
                            </Text>
                            <div className='recruit-process'><img src={imgProcess}/></div>
                            <br /><br />

                            {/* 입사 지원서 및 접수처 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 입사 지원서 및 접수처</div>
                            </Text>
                            {currentOnlyNotice.map((selectedRecruit) => {
                            return <div>
                            <Text variant='px20w400_rec'>
                                <div className='recruit-content-items'>- 입사 지원서 : <AttachFiles uploadId={selectedRecruit.Uploadid} /> </div>
                                <div className='recruit-content-items'>- 접수처 : {selectedRecruit.Email}</div>
                                <div className='recruit-content-items'>- 접수 기한 : {selectedRecruit.Noti_dt} ~ 모집 완료 시</div>
                            </Text> 
                            <br /><br />

                            {/* 근무 조건 및 환경 */}
                            <Text variant='px20w600_rec' >
                                <div className='recruit-content-title'>◆ 근무 조건 및 환경</div>
                            </Text>
                            <Text variant='px20w400_rec'>
                                <div className='recruit-content-items'>- 근무 부서 : {selectedRecruit.Dept} ({selectedRecruit.Area}근무)</div>
                                <div className='recruit-content-items'>- 근무 시간 : 주5일, 오전 8시 ~ 오후 5시 (유연근무제 사용 가능)</div>
                                <div className='recruit-content-items'>- 급여 : 회사 내규에 따름</div>
                                <div className='recruit-content-items'>- 복지 : 
                                    <div className='toCompCulture' onClick={() => toCompCultureClick()}> 
                                        <Text variant='px20w400B'>
                                            인사제도 페이지 이동
                                        </Text>
                                    </div>
                                </div>
                            </Text> 

                                </div>

                            })}
                                

                            
                        </div>
                    </div>

                {/* 진행중인 채용 */}
                <div className='active-container'>
                        <Text variant='px28' >진행 중인 채용 ({sideNotice.length})</Text>
                        <div className='activeCardWrap'>
                            {sideNotice.map((sideRecruit) => {
                                return <div className='recruit-active-card' onClick={() => sideRecruitBtnClick(sideRecruit.Seq)}>
                                        <Text variant='px20w600_rec'>{sideRecruit.Noti_title}</Text>
                                        <br/>
                                        <Text variant='px16w400c66'>{sideRecruit.Dept}</Text>
                                    </div>

                            })}
                        </div>

                        <button className='recruitAll' onClick={() => tolistBtnClick()}>전체보기</button>
                </div>
                </div>

        </div>
    </div>


    );

}

export default RecruitmentDetail;